import Vuex from 'vuex';
import Vue from 'vue';
import gql from 'graphql-tag';

export default new Vuex.Store({
    state: {
        channels: [],
        loaded: false,
        currentChannel: null,
        showChannelSwitcher: false,
    },
    mutations: {
        setChannels(state, value) {
            state.channels = value;
        },
        setLoaded(state, value) {
            state.loaded = value;
        },
        setCurrentChannel(state, value) {
            state.currentChannel = value;
        },
        setShowChannelSwitcher(state, value) {
            state.showChannelSwitcher = value;
        },
    },
    actions: {
        loadChannels({commit}) {
            return Vue.$graphql.query({
                query: gql`
                    query getChannels {
                        getChannels {
                            indexname
                            url
                            countries
                            channel_redirects {
                                channel_id
                                country_id
                                redirect_url
                                page_url
                            }
                        }
                    }
                `
            }).then(
                r => r.data
            ).then(data => {
                if (data.getChannels) {
                    commit('setChannels', data.getChannels);
                }
            }).catch(
                () => {}
            );
        },
    },
});